import { Base, Component, Prop } from '@/vue-property-decorator'
import { CardListOneProps } from '@/views/game/components/gameCardSuit2/cardList/listOne'
import { GameItemInter } from '@/service/game/entity/gameItem'
import {
  GameLayoutList,
  SquareBelowName
} from '@/views/game/components/gameCardSuit2'
import { _ListLayoutHome as ListLayoutHome } from './listLayoutHome'
import { _ListLayoutSearch as ListLayoutSearch } from './listLayoutSearch'
import { _ListLayoutSubGame as ListLayoutSubGame } from './listLayoutSubGame'
import { SquareGalaxy } from '@/views/game/components/gameCardSuit'
// import { createGetBoxCutRadius } from '@/views/game/utils/createGetBoxCutRadius'
import { gameHelper } from '@/views/game/services'
// import { useMainStore } from '@/store/index'
import AppTypes from '@/vue-types'
import Skin from '@/controller/Skin'
interface Props {
  /** 列表数据 */
  listData: Array<GameItemInter>
  /** 布局数据 */
  listLayout: 'home' | 'subGame' | 'seach' | 'embedded'
  /** 当前活跃的TabKey是否为[热门,最近,收藏] */
  isHotRecentCollect: boolean
  /** 当前是否为平台卡片 */
  isPlatformGameCatgory: boolean
}
/** 游戏列表的参数 */
export type ListLayoutParams = {
  /** 是为否为[热门|最近|收藏]状态的[平台卡片],同时满足这两个条件的,需要做特殊的渲染 */
  isHotRecentCollectPlatformCard?: boolean
}
@Component<GameListSquare>({
  name: 'GameListSquare'
})
export default class GameListSquare extends Base<unknown, Props> {
  @Prop(AppTypes.array.def([]))
  private listData!: Props['listData']
  @Prop()
  private listLayout!: Props['listLayout']

  private get localListLayout() {
    const mapper: Record<
      Props['listLayout'],
      new (...params: unknown[]) => CardListOneProps
    > = {
      home: ListLayoutHome,
      subGame: ListLayoutSubGame,
      seach: ListLayoutSearch,
      embedded: ListLayoutSearch
    }
    return new mapper[this.listLayout](gameHelper.isSpecialPlatformGameCatgory)
  }

  /** 根据不同的版式,选择不同的渲染组件 */
  private get DynamicCardComponent() {
    const { isGalaxyGold, isCrownGold } = Skin.currentTheme()
    // 银河金和皇冠金,都使用心型收藏按钮. 这两个还是使用旧版的布局方案
    if (isGalaxyGold || isCrownGold) {
      return {
        Square: SquareGalaxy,
        CssVar: SquareGalaxy.CssVarDefault
      }
    } else {
      return {
        Square: SquareBelowName
      }
    }
  }

  /** 渲染列表,单独将它提出来,因为银河金和皇冠金还得使用旧版的渲染方案 */
  private renderList() {
    const { DynamicCardComponent } = this
    return (
      <GameLayoutList props={this.localListLayout}>
        {this.listData.map((item) => {
          const props = SquareBelowName.getProps(item)
          // const radius = this.getBoxCutRadius(props.status)
          return (
            <DynamicCardComponent.Square
              cssSizeType={SquareBelowName.CssSizeType.Default}
              key={item.webId}
              // cssVarManagerMust={{
              //   boxCut: { '--box-cut-border-radius': radius },
              //   maskMaintain: {
              //     '--mask-maintain-border-radius': radius
              //   }
              // }}
              props={props}
            />
          )
        })}
      </GameLayoutList>
    )
  }

  render() {
    const { DynamicCardComponent } = this
    // 这里要兼容桌版银河金的内容
    if (DynamicCardComponent.CssVar) {
      return (
        <DynamicCardComponent.CssVar>
          {this.renderList()}
        </DynamicCardComponent.CssVar>
      )
    } else {
      return this.renderList()
    }
  }
}
